import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=005c0b67&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=005c0b67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c0b67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005c0b67')) {
      api.createRecord('005c0b67', component.options)
    } else {
      api.reload('005c0b67', component.options)
    }
    module.hot.accept("./NewUser.vue?vue&type=template&id=005c0b67&scoped=true", function () {
      api.rerender('005c0b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewUser/NewUser.vue"
export default component.exports